import { Span, SpanProcessor } from '@opentelemetry/sdk-trace-base';
export class HttpUrlPathProcessor implements SpanProcessor {
  // This should eventually be moved to onEnding if it ever goes stable
  // ref https://github.com/open-telemetry/opentelemetry-specification/pull/4024
  onStart(span: Span): void {
    const candidateAttributes = {
      ["http.url"]: "http.path_pattern",
      ["page.url"]: "page.path_pattern",
      ["url.path"]: "url.path_pattern",
      ["entry_page.path"]: "entry_page.path_pattern"
    };
    for (const [fromAttrName, toAttrName] of Object.entries(candidateAttributes)) {
      if (span.attributes[fromAttrName]) {
        try {
          const attrValue = String(span.attributes[fromAttrName]);
          let pathName = attrValue;
          if (/^https?:\/\//.test(attrValue)) {
            const url = new URL(attrValue);
            pathName = url.pathname;
          }
          // # Do transforms
          // ## id-like segments
          pathName = pathName.replaceAll(/\/\d+\//g, "/(\\d+)/");
          pathName = pathName.replaceAll(/\/\d+$/g, "/(\\d+)");

          // ## asset-cache hashes
          pathName = pathName.replaceAll(/\/static\/asset-cache\/[^/]+\//g, "/static/asset-cache/(hash)/");

          // ## Public dashboards
          pathName = pathName.replaceAll(/\/api\/app\/public\/dashboards\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, "/api/app/public/dashboards/(uuid)");
          pathName = pathName.replaceAll(/^\/public\/[^/]+/g, "/public/(id)");
          span.setAttributes({
            [toAttrName]: pathName
          });
          // eslint-disable-next-line no-empty
        } catch (_) {}
      }
    }
  }
  onEnd(): void {}
  forceFlush() {
    return Promise.resolve();
  }
  shutdown() {
    return Promise.resolve();
  }
}